const index = () => import(/* webpackChunkName: "herb" */ './Index');
const edit = () => import(/* webpackChunkName: "herb" */ './Edit');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/china/v2019/index',
      name: 'chinaV2019Index',
      component: index,
      meta:{public:true}
    },
    {
      path: '/china/v2019/edit/:dbid?',
      name: 'chinaV2019edit',
      component: edit,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/china2025/v2019/router.js